import PropTypes from "prop-types"


const FormShape = PropTypes.shape({
  getFieldValue: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
})

export default FormShape
